import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import VideoTranscriptTool from './Components/VideoTranscriptTool.vue';

import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf";

GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url
).toString();

const app = createApp({
    components: {
        VideoTranscriptTool,
    },

    mounted() {
        // ScrollMove button click buttom to Top
        document.addEventListener('DOMContentLoaded', () => {
            const buttons = document.querySelectorAll('.scrollMove');
            buttons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.body.scrollIntoView({
                        top: 0,
                        behavior: 'smooth',
                    });
                });
            });
        });
    },
});
app.mount('#app');


document.addEventListener("DOMContentLoaded", () => {
    const scrollButton = document.getElementById("scrollMove");
    if (scrollButton) { // Ensure scrollButton exists before adding event listener
        scrollButton.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    document.getElementById('toggleMenu').addEventListener('click', function () {
        let menu = document.getElementById('menuItems');
        menu.classList.toggle('hidden');
    });
});
